import { useEffect, useState } from 'react'
import { Button, ButtonGroup, Container } from 'react-bootstrap'
import { observer } from 'mobx-react-lite'
import { useTranslation } from 'react-i18next'
import { ActivityModes } from '../app/models/modes'
import { useStore } from '../app/stores/store'
import AuctionCard from './components/auction/AuctionCard'
import FooterNew from './components/Footer'
import LogsTable from './components/LogsTable'
import InvoicesTable from './components/InvoicesTable'
import ComponentLoader from './components/loaders/ComponentLoader'
import PostCard from './components/post/PostCard'
import CustomPagination from './components/buttons/CustomPagination'

function ActivityPage() {
  const { activityStore } = useStore()
  const { activity, isAuction, isLogsArray, isPost } = activityStore
  const [mode, setMode] = useState(ActivityModes.myAuctions)
  const [loadingInitial, setLoadingInitial] = useState(true)
  const [page, setPage] = useState(1)
  const paginateLength = 9
  const { t } = useTranslation()

  useEffect(() => {
    setLoadingInitial(true)
    activityStore.loadAuctions(mode).finally(() => setLoadingInitial(false))
  }, [activityStore, mode])

  const filter = [
    { title: t('wins'), value: ActivityModes.wins },
    { title: t('engagement'), value: ActivityModes.engagement },
    { title: t('my_auctions'), value: ActivityModes.myAuctions },
    { title: 'My Posts', value: ActivityModes.myPosts },
    { title: t('logs'), value: ActivityModes.logs },
    { title: t('invoices'), value: ActivityModes.invoices },
  ]

  function paginate(array: any) {
    return array.slice((page - 1) * paginateLength, page * paginateLength)
  }

  return (
    <>
      <Container fluid className='navigation-container'>
        <div className='activity-nav'>
          <ButtonGroup className='d-flex'>
            {filter.map((f, index) => (
              <Button
                onClick={() => setMode(f.value)}
                active={f.value === mode}
                variant='light'
                key={index}
              >
                {f.title}
              </Button>
            ))}
          </ButtonGroup>
        </div>
      </Container>
      {loadingInitial ? (
        <ComponentLoader mTop={100} />
      ) : (
        <>
          <Container fluid className='auction-container'>
            <div className='auction-content'>
              {mode !== ActivityModes.logs && mode !== ActivityModes.invoices && (
                <>
                  {activity.length === 0 && (
                    <h1 className='mt-5 text-center'>
                      {t('activity_page.nothing_found', {
                        item: mode === ActivityModes.myPosts ? t('posts') : t('auctions')
                      })}
                    </h1>
                  )}
                  <div className='auction-list mb-5'>
                    {paginate(
                      activity.map((data, index) =>
                        isAuction(data) ? (
                          <AuctionCard key={index} auction={data} />
                        ) : isPost(data) ? (
                          <PostCard key={index} post={data} />
                        ) : null,
                      ),
                    )}
                  </div>
                  <CustomPagination
                    page={page}
                    setPage={setPage}
                    arrayLength={activity.length}
                    paginateLength={paginateLength}
                  />
                </>
              )}
              {mode === ActivityModes.logs && isLogsArray(activity) && (
                <LogsTable logs={activity} />
              )}
              {mode === ActivityModes.invoices && <InvoicesTable />}
            </div>
          </Container>
          <br />
          <FooterNew />
        </>
      )}
    </>
  )
}
export default observer(ActivityPage)
